import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

export class VWAPChangeNotification {
  constructor(public vwapString: string, public source: string) {}
}

export class BfxVwapInfo {
  private vwapUpdateSubject: Subject<VWAPChangeNotification> = new Subject();
  public vwapUpdates: Observable<VWAPChangeNotification> = this.vwapUpdateSubject.asObservable();

  push(notif: VWAPChangeNotification) {
    this.vwapUpdateSubject.next(notif);
  }
}
